import React, { useContext, useMemo, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import { SidebarV2 } from 'components/Sidebar/SidebarV2';
import { ErrorHandler } from 'ErrorHandler';
import { useRoutes } from 'hooks/useRoutes';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { Box } from '@mui/material';
import {
  DEFAULT_PARTNER_PAGE,
  DEFAULT_LENDER_PAGE,
  DEFAULT_DEALER_PAGE,
  expandedSidebarWidth,
  collapsedSidebarWidth,
} from 'constants/common';
import { PortalNotificationsDrawer } from 'modules/portalNotifications';

export const Dashboard = () => {
  const { isDealerUser, isLenderUser, isAftermarketPartner } = useContext(CommonDataContext);

  const { currentRouteConfig, availableAppRoutes, availalbeUserRoutes } = useRoutes();

  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isPortalNotificationsOpen, setIsPortalNotificationsOpen] = useState(false);

  const handlePortalNotificationsToggle = () => setIsPortalNotificationsOpen(prev => !prev);

  const availableRoutes = [...availableAppRoutes, ...availalbeUserRoutes];

  const routeToRedirect =
    useMemo(() => {
      if (isAftermarketPartner) return DEFAULT_PARTNER_PAGE;
      if (isDealerUser) return DEFAULT_DEALER_PAGE;
      if (isLenderUser) return DEFAULT_LENDER_PAGE;
    }, [isDealerUser, isLenderUser, isAftermarketPartner]) ?? '';

  const toggleSidebar = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <ErrorHandler>
      <SidebarV2
        isDrawerOpen={isDrawerOpen}
        toggleSidebar={toggleSidebar}
        onNotificationsIconClick={handlePortalNotificationsToggle}
      />

      <PortalNotificationsDrawer
        isDrawerOpen={isDrawerOpen}
        isOpen={isPortalNotificationsOpen}
        onClose={() => setIsPortalNotificationsOpen(false)}
      />

      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          overflow: 'hidden',
          position: 'relative',
          boxSizing: 'border-box',
          padding: `4rem 0.5rem 0.5rem calc(${isDrawerOpen ? expandedSidebarWidth : collapsedSidebarWidth}px + 8px)`,
        }}
      >
        <AdminNavbar
          isDrawerOpen={isDrawerOpen}
          brandText={currentRouteConfig?.name}
          fastTrackOption={currentRouteConfig?.fastTrackOption}
        />

        <Switch>
          <Redirect exact from="/" to={routeToRedirect} />
          {/* if authorized user clicks welcome link from email */}
          <Redirect exact from="/welcome" to={routeToRedirect} />

          {availableRoutes.map(route => (
            <Route key={route.id} path={route.path} component={route.component} exact={route.exact} />
          ))}
        </Switch>
      </Box>
    </ErrorHandler>
  );
};
